module.exports = __webpack_public_path__ + "img/logo.34098f05.png";